import { render } from "./ProducerOrderDeliveryReminderModal.vue?vue&type=template&id=3223a74e"
import script from "./ProducerOrderDeliveryReminderModal.vue?vue&type=script&lang=js"
export * from "./ProducerOrderDeliveryReminderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__